import axios, { AxiosRequestConfig } from "axios";
export const API_SERVER_ENDPOINT = process.env.REACT_APP_API_SERVER_ENDPOINT;
export const MSG_SERVER_ENDPOINT = process.env.REACT_APP_MSG_SERVER_ENDPOINT;

class ApiInstanceClass {
  instance;

  constructor() {
    this.instance = axios.create({
      withCredentials: true,
      timeout: 3000,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": `http://localhost:3001`,
        "Access-Control-Allow-Credentials": true,
      },
    });
  }

  request(params: AxiosRequestConfig) {
    return this.instance.request(params);
  }

  get(
    url: string,
    type?: { isMsg: boolean },
    params?: { [key: string]: string }
  ) {
    return this.instance.get(
      (type?.isMsg ? MSG_SERVER_ENDPOINT : API_SERVER_ENDPOINT) + url,
      params
    );
  }

  post(
    url: string,
    type?: { isMsg: boolean },
    body?: any,
    config?: AxiosRequestConfig
  ) {
    return this.instance.post(
      (type?.isMsg ? MSG_SERVER_ENDPOINT : API_SERVER_ENDPOINT) + url,
      body,
      config
    );
  }

  put(url: string, body: any, type?: { isMsg: boolean }) {
    return this.instance.put(
      (type?.isMsg ? MSG_SERVER_ENDPOINT : API_SERVER_ENDPOINT) + url,
      body
    );
  }

  del(url: string, body: { [key: string]: string }, type?: { isMsg: boolean }) {
    return this.instance.delete(
      (type?.isMsg ? MSG_SERVER_ENDPOINT : API_SERVER_ENDPOINT) + url,
      body
    );
  }
}

const apiInstance = new ApiInstanceClass();

export default apiInstance;
